import { createQueryString } from '@eika-infrastruktur/utils';

import type {
    CrossBorderPaymentRequest,
    CrossBorderPaymentsStatus,
    ApprovalResult,
    ValidateCrossBorderResponse,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { post, get } from './request';

const SERVICE_PATH = `${CONTEXT_PATH}/rest/resource/payments/crossborder`;

export function getStatus(): Promise<CrossBorderPaymentsStatus> {
    return get<CrossBorderPaymentsStatus>(`${SERVICE_PATH}/status`);
}

export function validatePayment(
    paymentRequest: CrossBorderPaymentRequest,
    acceptDuplicate = false,
): Promise<ValidateCrossBorderResponse> {
    const queryString = createQueryString({
        acceptDuplicate: acceptDuplicate.toString(),
    });
    return post<ValidateCrossBorderResponse>(`${SERVICE_PATH}/validate${queryString}`, paymentRequest);
}

export function payCrossBorderPayment(
    request: CrossBorderPaymentRequest,
    acceptDuplicate = false,
    ignorePbdWarning = false,
    ignoreSepaWarning = false,
): Promise<ApprovalResult> {
    const queryString = createQueryString({
        acceptDuplicate: acceptDuplicate.toString(),
        ignorePbdWarning: ignorePbdWarning.toString(),
        ignoreSepaWarning: ignoreSepaWarning.toString(),
    });
    return post<ApprovalResult>(SERVICE_PATH + queryString, request);
}
